export default __webpack_public_path__ + "static/media/qr_m04.45cda84c.jpg";